import React, { PropsWithChildren } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

const RouterProvider: React.FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <Router>{children}</Router>;
};

export default RouterProvider;
